import { AsyncValidatorFn } from '@angular/forms';

export function phoneExistsValidator(exists: boolean): AsyncValidatorFn {
  return (): any => {
    return exists ? { phoneExists: true } : null;
  };
}
export function phoneDoesNotExistValidator(exists: boolean): AsyncValidatorFn {
  return (): any => {
    return exists ? { phoneDoesNotExist: true } : null;
  };
}
